<template>
  <v-container class="pa-0 contactUs-container" fluid>
    <breadcrumbs-banner
      :bannerTitle="$t('header.contactUs')"
    ></breadcrumbs-banner>
    <map-component></map-component>
    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3">
      <v-row>
        <v-col cols="12" lg="4">
          <v-row class="my-lg-0 justify-center">
            <v-col
              class="d-flex align-center justify-center justify-lg-start"
              cols="12"
            >
              <v-img
                class="float-left"
                contain
                max-width="45"
                src="/wsIncocegla.svg"
                width="45"
              ></v-img>
              <h6
                class="
                  text-lg-h6 text-body-1 text-navy
                  font-weight-bold
                  float-left
                  ml-5
                "
              >
                (849) 455-9997
              </h6>
            </v-col>
            <v-col
              class="
                d-flex
                align-center
                my-lg-10
                justify-center justify-lg-start
              "
              cols="12"
            >
              <v-img
                class="float-left"
                max-width="45"
                src="/telefonofilled.svg"
                width="45"
              ></v-img>
              <h6
                class="
                  text-lg-h6 text-navy text-body-1
                  font-weight-bold
                  text-center
                  float-left
                  ml-5
                "
              >
                (809) 333-4512 (Sto. Dgo.)
                <br><br class="mb-n5">
                (809)-655-4112 (Romana)
              </h6>
            </v-col>

            <v-col
              class="d-flex align-center justify-center justify-lg-start mt-lg-n4 mb-5"
              cols="12"
            >
              <v-img
                class="float-left"
                max-width="50"
                src="/mail.svg"
                width="50"
              ></v-img>
              <h6
                class="
                  float-left
                  text-lg-h6 text-navy text-body-1
                  font-weight-bold
                  text-center
                  ml-5
                "
              >
                info@incocegla.org.do
              </h6>
            </v-col>

            <v-col cols="12">
              <v-img
                class="float-left  mb-lg-3"
                src="/icon-clock.svg"
                width="45"
              ></v-img>
              <h6 class="float-left text-h6 text-navy font-weight-bold ml-5" v-html="$t('home.schedule')">

              </h6>
            </v-col>
          </v-row>
<!--          <v-btn-->
<!--            class="-->
<!--              d-flex-->
<!--              mx-auto mx-lg-0-->
<!--              elevation-0-->
<!--              rounded-xl-->
<!--              background-green-light-->
<!--              text-white text-capitalize text-lg-h6-->
<!--              font-weight-bold-->
<!--              mt-lg-10-->
<!--              my-5-->
<!--              px-0-->
<!--              mb-lg-0-->
<!--            "-->
<!--            href="https://wa.link/brccem"-->
<!--            max-width="300"-->
<!--          >-->
<!--            {{ $t('home.scheduleAnAppointment') }}-->
<!--          </v-btn>-->
        </v-col>
        <v-col
          class="pl-lg-16 border-left-green remove-border mt-5 mt-lg-0"
          cols="12"
          lg="8"
        >
          <h4
            class="
              text-lg-h4 text-h5 text-center text-lg-left text-navy
              font-weight-bold
              pl-lg-16
            "
            v-html="$t('contactUs.moreInformation')"
          ></h4>
          <v-form v-model="valid" class="pl-lg-16">
            <v-container>
              <v-row class="mx-lg-n5">
                <v-col cols="12">
                  <v-text-field
                    v-model="formContact.name"
                    :counter="50"
                    :label="$t('contactUs.firstName')"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="formContact.email"
                    :label="$t('contactUs.email')"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="formContact.message"
                    :label="$t('contactUs.message')"
                    :rules="messageRules"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-btn
                class="
                  elevation-0
                  mt-lg-10 mt-5
                  btn-first
                  text-capitalize text-lg-h6
                  font-weight-bold
                  ml-lg-n2
                "
                outlined
                width="200"
                @click="sendMessage()"
              >
                {{ $t('contactUs.send') }}
              </v-btn
              >
              <v-alert v-if="send" class="mt-5" dense text type="success">
                {{ $t('contactUs.alertSuccess') }}
              </v-alert>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
import mapComponent from '../components/map.vue'
import ContactService from '@/services/contact'

export default {
  components: {
    mapComponent,
  },
  data() {
    return {
      valid: false,
      formContact: {
        name: '',
        email: '',
        message: '',
      },
      send: false,
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 50 || 'Name must be less than 10 characters',
      ],

      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      messageRules: [
        (v) => !!v || 'Message is required',
        (v) => v.length <= 250 || 'Name must be less than 10 characters',
      ],
    }
  },
  methods: {
    async sendMessage() {
      if (
        this.formContact.name &&
        this.formContact.email &&
        this.formContact.message
      ) {
        ContactService.sendEmail(this.formContact).then(() => {
          this.send = true
          this.formContact.name = null
          this.formContact.email = null
          this.formContact.message = null
        })
      }
    },
  },
}
</script>

